module.exports = __webpack_public_path__ + "media/images/about-slider-img-05-40c52e71c4854b9f6416b171e13d2cc9.jpg";